import { render, staticRenderFns } from "./AssetStateForm.vue?vue&type=template&id=3610d947&scoped=true"
import script from "./AssetStateForm.vue?vue&type=script&lang=js"
export * from "./AssetStateForm.vue?vue&type=script&lang=js"
import style0 from "./AssetStateForm.vue?vue&type=style&index=0&id=3610d947&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3610d947",
  null
  
)

export default component.exports